module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_03_770_280_ja-3e6815616d1df88ec10a0e4db26ca6ba.jpg";